import { gql } from '@apollo/client'

const GET_NONPROFIT_ORG_CONFIG_QUERY = gql`
  query getNonprofitOrgConfig($nonprofitOrgId: Int) {
    nonprofitOrg(nonprofitOrgId: $nonprofitOrgId) {
      orgName
      orgId
      legalName
      user {
        id
        firstName
        lastName
        email
        phone
        nonprofitExperienceRange
        updatedAt
      }
      role
      formationPlan
      platformPlan
      stripeConnectId
      isStripeConnectActive
      stripeConnectIssues {
        errors
        resumeKYCUrl
        pendingVerification
        missingBusinessUrl
      }
      permissions
      logoBoxId
      websiteUrl
      nonprofitOrgRole
      hasTaxExemptStatusAtSignup
      ein
      isFiscallySponsored
      is501c3Verified
      isBipocLed
      isBipocServing
      yearEstablished
      address
      featureFlags
      logoCloudinaryFileId
      paidStaffSizeRange
      volunteerSizeRange
      numBoardMembers
      numTeamMembers
      donationPortalId
      donationPortalHashedId
      isFounder
      donationFeePercent
      missionStatement
      taxExemptionStatus
      platformPlanAddOns
      funderOrgId
      activeFunders
    }
  }
`

export default GET_NONPROFIT_ORG_CONFIG_QUERY
